export default __webpack_public_path__ + "34bc2a70b8ad7b85b5cfa1afed5d33a3.png";